module.exports = __webpack_public_path__ + "static/media/grid4.9dfe9061.jpg";